export const defaultEditorConfig = {
  toolbarButtons: [
    [
      'bold',
      'italic',
      'underline',
      'strikeThrough',
      'subscript',
      'superscript',
      'fontFamily',
      'fontSize',
      'textColor',
      'backgroundColor',
      'align',
      'formatOL',
      'formatUL',
      'insertTable',
      'insertImage',
      'specialCharacters',
      'clearFormatting',
    ],
  ],
  listAdvancedTypes: true,
  tableEditButtons: [
    'tableHeader',
    'tableRemove',
    '|',
    'tableRows',
    'tableColumns',
    'tableStyle',
    '-',
    'tableCells',
    'tableCellBackground',
    'textColor',
    'tableCellVerticalAlign',
    'tableCellHorizontalAlign',
    'tableCellStyle',
  ],
  heightMin: 240,
  fontFamily: {
    Gotham: 'Gotham',
    Calibri: 'Calibri',
    Montserrat: 'Montserrat',
    MontserratBold: 'Montserrat Bold',
    MontserratSemiBold: 'Montserrat Semi Bold',
    MontserratSemiMedium: 'Montserrat Semi Medium',
    MyriadPro: 'Myriad Pro',
    MyriadProLight: 'Myriad Pro Light',
    MyriadProBold: 'Myriad Pro Bold',
    InterBold: 'Inter Bold',
    InterSemiBold: 'Inter Semi Bold',
    InterMedium: 'Inter Medium',
    InterLight: 'Inter Light',
    InterThin: 'Inter Thin',
  },
  fontFamilySelection: true,
  fontFamilyDefaultSelection: 'Myriad Pro',
}
